import { DEFAULT_LOCALE, isLocale, negotiateLocale, type Locale } from '@wms/shared';
import { DEFAULT_NAMESPACE, NAMESPACES, resources } from '@wms/i18n';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'wms.locale';

/**
 * 语言解析顺序（架构书 §14）：用户偏好（登录后由 profile 覆盖）→ localStorage
 * → Accept-Language → 默认。任何时刻界面只显示一种语言（Spec §2）。
 */
export function resolveInitialLocale(): Locale {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  if (isLocale(stored)) return stored;
  if (typeof navigator !== 'undefined') return negotiateLocale(navigator.languages?.join(','));
  return DEFAULT_LOCALE;
}

export async function initI18n(locale: Locale = resolveInitialLocale()): Promise<void> {
  await i18next.use(initReactI18next).init({
    resources: resources as never,
    lng: locale,
    fallbackLng: DEFAULT_LOCALE,
    ns: [...NAMESPACES],
    defaultNS: DEFAULT_NAMESPACE,
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  document.documentElement.lang = locale;
}

export async function changeLocale(locale: Locale): Promise<void> {
  localStorage.setItem(STORAGE_KEY, locale);
  await i18next.changeLanguage(locale);
  document.documentElement.lang = locale;
}

export { i18next };
